import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AngularModule } from '../../../../modules/angular.module';
import { ListComponent } from '../list/list.component';
import { NavigationService } from '../../../../services/navigation.service';
import { AdminService } from '../../../../services/admin.service';
import { CognitoUserPool } from '@mira-avant/mtlibs';
import { ZorroModule } from '../../../../modules/zorro.module';
import { CognitoService } from '../../../../services/cognito.service';

@Component({
	selector: 'app-user-pool-list',
	standalone: true,
	imports: [AngularModule, ListComponent, ZorroModule],
	templateUrl: './user-pool-list.component.html',
	styleUrl: './user-pool-list.component.scss',
})
export class UserPoolListComponent {
	private readonly cognitoService = inject(CognitoService);
	private readonly adminService = inject(AdminService);
	private readonly nav = inject(NavigationService);

	public readonly pools = toSignal(this.cognitoService.pools$, { initialValue: [] });
	private readonly selectedPool = toSignal(this.adminService.selectedUserPool$, { initialValue: undefined });
	public readonly selectedUuid = computed(() => this.selectedPool()?.id);

	public select(pool: CognitoUserPool): void {
		this.nav.navigate([
			'my',
			'admin',
			'iam',
			{
				userPoolUuid: pool.id,
			},
		]);
	}
}
